import { gql } from "@apollo/client";

export const typeDefs = gql`
  type JobInput {
    type: String!
    employer: String
    role: String!
    start: DateTime!
    end: DateTime
    annual_income: Float!
  }

  type EducationInput {
    institution: String!
    location: String
    degree: String!
    graduated: DateTime
  }
`;
